import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Fetch the live navigation tree from the CMS.
 * Falls back to `fallback` (the hardcoded nav array) when the API is
 * unreachable so the site never has a missing nav.
 */
export function useNavigation(fallback = []) {
  const [nav, setNav] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/navigation`)
      .then(r => { if (!cancelled) setNav(r.data); })
      .catch(() => { if (!cancelled) setNav(null); });
    return () => { cancelled = true; };
  }, []);

  if (!nav) return { items: fallback, loading: true, source: "fallback" };

  // Build parent+children tree matching the shape the Header expects:
  // [{ label, path, children?: [{ to, label }], to?: string, external? }]
  const tops = nav.filter(i => !i.parent_id).sort((a, b) => a.display_order - b.display_order);
  const items = tops.map(t => {
    const kids = nav.filter(i => i.parent_id === t.id).sort((a, b) => a.display_order - b.display_order);
    const isExternal = /^https?:\/\//i.test(t.path);
    return kids.length > 0
      ? { label: t.label, to: t.path, external: isExternal || t.open_in_new_tab,
          children: kids.map(k => ({
            to: k.path, label: k.label, external: /^https?:\/\//i.test(k.path) || k.open_in_new_tab,
          })) }
      : { label: t.label, to: t.path, external: isExternal || t.open_in_new_tab };
  });

  return { items, loading: false, source: "cms" };
}
